import config from '../config';
import selectedEnvironment from '../env';

const BASEAPI = config[selectedEnvironment].API_URL;
const API_URL = `${BASEAPI}/UserFeedback`;

const UserFeedbackService = {
  create: async (token, { rating, comment, category, source = 'Web' }) => {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ rating, comment, category, source }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data?.message || data?.errors?.[0] || 'Failed to submit feedback');
    }
    return data;
  },

  getEligibility: async (token) => {
    const response = await fetch(`${API_URL}/eligibility`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      return { hasSubmittedBefore: false, canAutoPrompt: true };
    }
    return data?.data ?? data;
  },
};

export default UserFeedbackService;
